import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import {
  DesireToWork,
  JapaneseHoliday,
  Master,
  Prefecture,
  Qualification,
  Service,
  Product
} from "@/types/Master";
import { systemService } from "@/app/services/SystemService";
import { RecommendationPoint } from "@/types/order/RecommendationPoint";
import { authStore } from "@/store/auth";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "master"
})
class MasterModule extends VuexModule {
  master!: Master;

  get products(): Product[] {
    return this.master.products;
  }

  get visibleQualifications(): Qualification[] {
    return this.master.qualifications.filter(q => q.isVisible);
  }

  get services(): Service[] {
    return this.master.services;
  }

  get desireToWorks(): DesireToWork[] {
    return this.master.desireToWorks;
  }

  get qualificationMap(): Map<number, Qualification> {
    const map = this.master.qualifications.reduce((acc, obj) => {
      acc.set(obj.id, obj);
      return acc;
    }, new Map());
    return map;
  }

  get banks() {
    return this.master.banks;
  }

  get prefectures(): Prefecture[] {
    return this.master.prefectures;
  }

  // 事業所用のサービス種類コードの取得（選択肢をプロダクトによって変えるため authStore.product.orderServices から取得する）
  get servicesForOffice(): Service[] {
    return authStore.product.orderServices.filter(service => {
      return !service.onlyWorkerExperience;
    });
  }

  // ワーカー用のサービス種類コードの取得（選択肢をプロダクトによって変えるため authStore.product.orderServices から取得する）
  get servicesForWorkerExperience(): Service[] {
    return authStore.product.orderServices;
  }

  get getServiceNameById() {
    return (id: number) =>
      this.master.services.find(service => service.id === id)?.name;
  }

  get recommendationPoints(): RecommendationPoint[] {
    return this.master.recommendationPoints;
  }

  get getOfferTypeSlugById() {
    return (id: number) =>
      this.master.offerTypes.find(offerType => offerType.id === id)?.slug;
  }

  get japaneseHolidays(): JapaneseHoliday[] {
    return this.master.japaneseHolidays;
  }

  @Mutation
  SET_MASTER(master: Master) {
    this.master = master;
  }

  @Action
  async fetchMaster() {
    const master = await systemService.fetchMaster();
    this.SET_MASTER(master);
  }
}

export const masterStore = getModule(MasterModule);
